import { Spinner } from '@tempmee/react';
import { lazy, Suspense } from 'react';
import { Center } from '~/commonComponents';
import { useOfficeTnCConsent } from '~/hooks/useOfficeTnCConsent';

const PDFPreviewConsent = lazy(() =>
  import('~/commonComponents/PDFPreviewConsent/PDFPreviewConsent').then((mod) => ({
    default: mod.PDFPreviewConsent,
  })),
);

export const TermsAndConditions = () => {
  const { isAccepting, handleAccept, pdfUrl, isLoading } = useOfficeTnCConsent();

  return (
    <Suspense
      fallback={
        <div className="component_container">
          <div
            className="floating_container"
            style={{
              flexDirection: 'column',
              justifyContent: 'flex-start',
              marginInline: '20px',
            }}
          >
            <Center marginTop={40}>
              <Spinner centered variant="default" size="md" />
            </Center>
          </div>
        </div>
      }
    >
      <PDFPreviewConsent
        pdfUrl={pdfUrl}
        isLoading={isLoading}
        isAccepting={isAccepting}
        onConsent={handleAccept}
      />
    </Suspense>
  );
};
